export default __webpack_public_path__ + "static/media/Disable-Icon.39d3ecf2.svg";